// Квадрат числа
export const square = (value: number): number => value * value;

// Квадратный корень числа
export const sqrt = (value: number): number => Math.sqrt(value);

// Округление к ближайшему
export const roundToIntegers = (value: number) => Math.round(value);
export const roundToTenths = (value: number) => Math.round(value * 10) / 10;
export const roundToHundredths = (value: number) => Math.round(value * 100) / 100;
export const roundToThousandths = (value: number) => Math.round(value * 1000) / 1000;
export const roundToMillionths = (value: number) => Math.round(value * 1000000) / 1000000;

// Округление вверх
export const ceilToTens = (value: number) => Math.ceil(value / 10) * 10;
export const ceilToIntegers = (value: number) => Math.ceil(value);
export const ceilToTenths = (value: number) => Math.ceil(value * 10) / 10;
export const ceilToHundredths = (value: number) => Math.ceil(value * 100) / 100;
export const ceilToThousandths = (value: number) => Math.ceil(value * 1000) / 1000;
export const ceilToMillionths = (value: number) => Math.ceil(value * 1000000) / 1000000;

export const getArraySum = (array: number[]) => array.reduce((sum: number, item: number) => sum + item, 0);
